var _rect, _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChildren(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4207 133.5L48.8463 124.233L118.763 123.465L114.688 128.025C98.2156 146.461 74.6649 157 49.9419 157C39.3932 157 29.5951 151.543 24.041 142.575L18.4207 133.5Z",
    fill: "#63CF99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1659 79.2658C77.2551 67.3397 92.2954 62 107.978 62L107.978 124.233L48.8467 124.233C48.8467 107.367 55.0766 91.1919 66.1659 79.2658Z",
    fill: "#FEDA5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.527 79.2658C162.616 91.1919 168.846 107.367 168.846 124.233H109.715L109.715 62C125.397 62 140.438 67.3397 151.527 79.2658Z",
    fill: "#4B8FE7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.272 124C142.272 107.197 142.606 94.9097 136.877 83.0283C131.148 71.1469 119.826 62 111.724 62C101.423 62 91.589 71.1469 85.86 83.0283C80.131 94.9097 81.1751 107.197 81.1751 124L111.724 124H142.272Z",
    fill: "#F46157"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.52 47.9912C115.461 48.6359 115.076 51.4884 113.033 51.5956L73.3859 53.677C65.9744 54.0661 61.089 46.0757 64.8135 39.6561C67.0353 35.8266 71.6396 34.0819 75.8413 35.4774L113.52 47.9912Z",
    fill: "#C1E9F6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.096 48.5904C99.0107 48.0804 99.3192 45.0248 101.464 44.9418L149.631 43.0796C156.969 42.7959 161.27 51.2399 156.725 57.0084C154.638 59.6583 151.195 60.8447 147.918 60.0432L101.096 48.5904Z",
    fill: "#C1E9F6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 111.535,
    cy: 49,
    r: 7,
    fill: "#F46157"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.272,
    cy: 103.077,
    r: 5.27197,
    fill: "#630000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.321,
    cy: 103.077,
    r: 5.27197,
    fill: "#630000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildren);
export default __webpack_public_path__ + "static/media/children.8f53ab3d82c7ecdc2d61d616251ea0b9.svg";
export { ForwardRef as ReactComponent };